var Appearance;

(function (Appearance) {
  Appearance["Disabled"] = "disabled";
  Appearance["Subtle"] = "subtle";
  Appearance["Solid"] = "solid";
  Appearance["Outline"] = "outline";
  Appearance["Inverse"] = "inverse";
  Appearance["SubtleOutline"] = "subtle-outline";
  Appearance["Vertical"] = "vertical";
  Appearance["DisabledVertical"] = "disabled-vertical";
})(Appearance || (Appearance = {}));

var Color;

(function (Color) {
  Color["Primary"] = "primary";
  Color["Ghost"] = "ghost";
  Color["Success"] = "success";
  Color["Warning"] = "warning";
  Color["Danger"] = "danger";
})(Color || (Color = {}));

var ButtonSize;

(function (ButtonSize) {
  ButtonSize["Small"] = "small";
  ButtonSize["Regular"] = "regular";
  ButtonSize["Regular2"] = "regular2";
  ButtonSize["Large"] = "large";
})(ButtonSize || (ButtonSize = {}));

var ButtonShape;

(function (ButtonShape) {
  ButtonShape["Sharp"] = "sharp";
  ButtonShape["Rounded"] = "rounded";
  ButtonShape["Circular"] = "circular";
})(ButtonShape || (ButtonShape = {}));

export { Appearance, ButtonShape, ButtonSize, Color };
